module.exports = __webpack_public_path__ + "static/media/member4.ed76803e.png";